export const RECEIVE_PROFILE = 'RECEIVE_PROFILE'

export const FETCH_PROFILE = 'FETCH_PROFILE'
